/* eslint-disable complexity */
import { FC, useCallback, useContext } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { AppRoutes } from '../../models'
import { QueryParamNames } from '../../models/QueryParamNames'
import { AuthContext, NewAppointmentContext } from '../../providers'
import { useGetRepairOrdersQuery } from '../../redux/api'
import { loggingAssert } from '../../utils/handleError/loggingAssert'
import { AppointmentForm } from '../AppointmentPanel'
import { APPOINTMENT_COLORS_DARK } from './AppointmentColorSelect'

export const NewAppointmentContainer: FC = () => {
  const navigate = useNavigate()
  const {
    date,
    setDate,
    selectedResource,
    setSelectedResource,
    setOpenPanel,
    selectedVehicle,
    selectedCustomer,
    selectedColor,
    setSelectedCustomer,
    setSelectedVehicle,
    setSelectedColor,
    setSelectedAppointment
  } = useContext(NewAppointmentContext)

  const { currentUser, userShopId } = useContext(AuthContext)
  const accessToken = loggingAssert('Token not set', currentUser?.accessToken)
  const shopId = loggingAssert('ShopId not set', userShopId)
  const [searchParams] = useSearchParams()

  const paramRepairOrderId = searchParams.get(QueryParamNames.REPAIR_ORDER_ID)

  const { data: repairOrders } = useGetRepairOrdersQuery(
    {
      authorization: accessToken,
      shop: shopId,
      repairOrder: [paramRepairOrderId!]
    },
    { skip: !paramRepairOrderId }
  )
  const submitCallBack = useCallback(async () => {
    setSelectedAppointment(undefined)
    setSelectedCustomer(undefined)
    setSelectedVehicle(undefined)
    setDate(new Date())
    setSelectedResource([])
    setSelectedColor(APPOINTMENT_COLORS_DARK[0])
    navigate(`${AppRoutes.APPOINTMENTS}`, { replace: true })
  }, [
    navigate,
    setDate,
    setSelectedAppointment,
    setSelectedColor,
    setSelectedCustomer,
    setSelectedResource,
    setSelectedVehicle
  ])
  const cancelCallBack = useCallback(async () => {
    setOpenPanel(false)
    setSelectedAppointment(undefined)
    setSelectedCustomer(undefined)
    setSelectedVehicle(undefined)
    setDate(new Date())
    setSelectedResource([])
    setSelectedColor(APPOINTMENT_COLORS_DARK[0])
  }, [
    setOpenPanel,
    setDate,
    setSelectedAppointment,
    setSelectedColor,
    setSelectedCustomer,
    setSelectedResource,
    setSelectedVehicle
  ])

  return (
    <>
      <AppointmentForm
        submitCallBack={submitCallBack}
        cancelCallBack={cancelCallBack}
        vehicle={selectedVehicle}
        customer={selectedCustomer}
        color={selectedColor}
        date={date}
        resources={selectedResource}
        cannedJobs={[]}
        services={[]}
        repairOrder={(repairOrders || [])[0]}
        setDateOutside={setDate}
        setResourceOutside={setSelectedResource}
        setCustomerOutside={setSelectedCustomer}
        setVehicleOutside={setSelectedVehicle}
        setColorOutside={setSelectedColor}
      />
    </>
  )
}
